import styles from './index.module.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
        <p>Lossless Wax © {currentYear} All Rights Reserved</p>
    </footer>
  )
}
export default Footer;